import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import App from "./App";
import store from "./store";
import { injectStore } from "~/helpers/apiHelper";
import AuthContext from "~/context/auth";
import AccessContext from "~/context/access";
import { randomStringSync } from "~/helpers/utilHelper";
injectStore(store);

// TEMPORARY create unique id for each tab opened by the user
if (!window.name) {
  window.name = randomStringSync(3);
}

const app = (
  <React.Fragment>
  <Provider store={store}>
    <AuthContext>
      <AccessContext>
        <App />
      </AccessContext>
    </AuthContext>
  </Provider>
  </React.Fragment>
);

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(app);
}
